var map = {
	"./client-01.png": 293,
	"./client-02.png": 9616,
	"./client-03.png": 8589,
	"./client-04.png": 7106,
	"./client-05.png": 4258,
	"./client-06.png": 4165,
	"./client-07.png": 6704,
	"./client-08.png": 4457,
	"./client-09.png": 8956,
	"./client-10.png": 7297,
	"./client-11.png": 375,
	"./client-12.png": 1229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2208;